import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const bannerWrapperCss = "b1x01l19";
const BannerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bannerWrapperCss, props.className)} />;
});
const leftContainerCss = "l3gf43l";
const LeftContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(leftContainerCss, props.className)} />;
});
const iconContainerCss = "i11uym0k";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const centeredTextCss = "c1sm76u0";
const CenteredText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(centeredTextCss, props.className)} />;
});
export const Banner = ({
  Icon,
  text,
  onClick,
  buttonText
}) => <BannerWrapper data-component="upgrade-banner">
    <LeftContainer>
      {Icon && <IconContainer>
          <Icon spacingRight={16} />
        </IconContainer>}
      <CenteredText>
        {text}
      </CenteredText>
    </LeftContainer>
    {onClick && buttonText && <Button onClick={onClick}>
        {buttonText}
      </Button>}
  </BannerWrapper>;

require("./banner.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./banner.js");